// extracted by mini-css-extract-plugin
export default {"timer":"index_timer_PpUDn","nowTime":"index_nowTime_pHv7Y","sound":"index_sound_gbCAn","noSound":"index_noSound_eLtNU"};